import {useEffect} from 'react';
import useUserAgent from './useUserAgent';
import {DEFAULT_ASPECT_RATIO} from '../constant';
import {
  DEFAULT_LARGE_SIZE,
  DEFAULT_MAX_WIDTH,
  DEFAULT_MEDIUM_SIZE,
} from '../scss/util/variable';
import {IUserAgent} from '../type';

export default function useResizeCssVars() {
  const userAgent = useUserAgent();
  useEffect(() => {
    if (!userAgent) return;

    let canRafCall = true;
    const onResize = () => {
      const innerWidth = window.innerWidth;
      const innerHeight = window.innerHeight;
      // raf 안에서 돔 계산하는 코드는 빼야한다.
      const screenHeight = getScreenHeightPx(userAgent, innerHeight);
      const paddingTop = getCellPaddingTopPx(innerWidth);

      canRafCall = false;
      canRafCall &&
        requestAnimationFrame(() => {
          setVariable(INNER_HEIGHT_VARIABLE, screenHeight);
          setVariable(CELL_PADDING_TOP_VARIABLE, paddingTop);
          canRafCall = true;
        });
    };

    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [userAgent]);
}

function setVariable(key: string, value: string) {
  document.documentElement.style.setProperty(key, value);
}

function getScreenHeightPx(userAgent: IUserAgent, innerHeight: number) {
  const isIosSafari = userAgent.isIos && userAgent.isSafari;
  const domHeight = document.documentElement.clientHeight;
  const height = innerHeight - (innerHeight > domHeight && isIosSafari ? 1 : 0);
  return `${height}px`;
}

function getCellPaddingTopPx(innerWidth: number) {
  const maxWidth =
    (innerWidth >= DEFAULT_LARGE_SIZE ? DEFAULT_MAX_WIDTH : innerWidth) + 4;
  const column = innerWidth >= DEFAULT_MEDIUM_SIZE ? 4 : 3;
  const cellWidth = maxWidth / column;
  const cellHeight = Math.floor(cellWidth * DEFAULT_ASPECT_RATIO);
  return `${cellHeight}px`;
}

const INNER_HEIGHT_VARIABLE = '--inner-height';
export const CELL_PADDING_TOP_VARIABLE = '--cell-padding-top';
